import React, { useState, useEffect } from 'react'
import { Button, Col, Icon, Message, Panel, Row } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanelWidget from '../ButtonPanelWidget'
import { startLoading, doneLoading } from '../../utils/loading'
import MiniProjectInfo from '../projectBasedItemsWidget/MiniProjectInfo'
import UpdateListForm from './UpdateListForm'
import UpdateListTable from './UpdateListTable'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import UpdateListFormView from './UpdateListFormView'
import {
  sessionGetItemJSON,
  sessionGetItemObj,
  sessionGetItemStr,
  sessionRemoveItem,
  sessionSetItemObj,
} from '../../utils/sessionHelpers'
import {
  DEFAULT_ERR_MSG,
  DELETE_ERR_MSG,
  DELETE_SUCCESS_MSG,
  ERR_MSG,
  SAVE_SUCCESS_MSG,
} from '../../constants/msgText'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import { downloadInstallmentIncomeAttacthment } from '../../redux/actions/incomeAndExpense'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import notification from '../../utils/notification'
import ConfirmWidget from '../confirm/ConfirmWidget'
import {
  deleteAdjust,
  downloadAdjustListFile,
  getAdjustAttachments,
  saveAdjust,
} from '../../redux/actions/accountingAdjust'
import moment from 'moment'
import { cloneDeep } from 'lodash'

export default function UpdateListWidgets(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [voucherSchema, setVoucherSchema] = useState()
  const [dataTable, setDataTable] = useState(props.schema.formTable)
  const [formDisplayLists, setFormDisplayLists] = useState()
  const [request, setRequest] = useState()
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false)

  const projectCode = sessionGetItemStr('projectCode')
  const periodInfo = sessionGetItemJSON('periodInfo')
  const { adjustId, editMode } = sessionGetItemObj('adjustData')

  let history = useHistory()

  const onDownloadOrPreview = async (fileObj, type) => {
    startLoading()
    setIsLoading(true)
    try {
      var file = await getAdjustAttachments(fileObj.id)
      var fileName = fileObj.name
      if ((type = 'download')) {
        downloadFile(file, fileName)
      } else {
        previewFile(file, fileName)
      }
    } catch (e) {
      // console.log(e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const onPreview = (fileObj) => {
    onDownloadOrPreview(fileObj, 'preview')
  }

  const onDownload = (fileObj) => {
    onDownloadOrPreview(fileObj, 'download')
  }

  const handleCallDelete = async () => {
    startLoading()
    setIsLoading(true)
    setIsShowConfirmDelete(false)
    try {
      let response = await deleteAdjust(adjustId)
      if (response) {
        notification.open('success', {
          title: DELETE_SUCCESS_MSG,
          duration: 5000,
        })

        sessionRemoveItem('adjustData')
        history.goBack()
      } else {
        notification.open('error', {
          title: DELETE_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      // console.log('error', e)
      notification.open('error', {
        title: DELETE_ERR_MSG,
        duration: 5000,
      })
      setIsShowConfirmDelete(false)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCallService = async () => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    setIsShowConfirm(false)

    try {
      let response = await saveAdjust(request)
      if (response) {
        //sessionSetItemObj('adjustData', { adjustId: rowData?.id, editMode: type == 'edit' })

        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })

        setRequest()

        sessionSetItemObj('adjustData', { adjustId: response.model.id, editMode: editMode })
        setFormSchema(response.model)
        setTimeout(() => {
          if (adjustId) {
            location.reload()
          } else {
            history.goBack()
          }
        }, 1000)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('handleCallService error', e)
      if (e?.response?.data) {
        console.log(e?.response?.data)
        setIsError(e.response.data.errorMessage || DEFAULT_ERR_MSG)
      } else {
        setIsError(DEFAULT_ERR_MSG)
      }
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)

    const formData = new FormData()

    formData.append('Id', adjustId || '')
    formData.append('ProjectCode', projectCode || '')
    formData.append('PeriodNumber', periodInfo?.periodNumber || 0)
    formData.append('DocumentDate', moment(data.documentDate).format('YYYY/MM/DD') || '' || '')
    formData.append('Description', data.description || '')
    formData.append('IsDraft', false)

    data.attachFiles &&
      data.attachFiles?.forEach((element) => {
        formData.append('AttachFiles', element.blobFile)
      })

    data.deleteFileIds &&
      data.deleteFileIds?.forEach((element) => {
        formData.append('DeleteFileIds', element)
      })

    const formTable = data.table?.filter((i) => !i.isRowTotal) || []
    // console.log('formTable', formTable)
    var validateAmount = false
    // var up = 0
    // var down = 0

    if (formTable.length > 1) {
      formTable?.forEach((item, index, arr) => {
        formData.set(`FormTable[${index}].Id`, item.id?.indexOf('addNew') != -1 ? '' : item.id)
        formData.set(`FormTable[${index}].Activity`, item.activity || '')
        formData.set(`FormTable[${index}].AdjustName`, item.adjustName || '')
        formData.set(
          `FormTable[${index}].BankAccount`,
          item.adjustTypeCode != '6600' && item.adjustTypeCode != '6800' ? '' : item.bankAccount
        )
        formData.set(`FormTable[${index}].AdjustTypeCode`, item.adjustTypeCode || '')
        formData.set(`FormTable[${index}].AdjustType`, item.adjustType || '')
        formData.set(`FormTable[${index}].SubProject`, item.subProject || '')
        formData.set(`FormTable[${index}].Amount`, item.amount || 0)
        // console.log('Amount==>', item.amount)
        // console.log('arr==>', arr[index].amount)
        if (index > 0) {
          if (item.amount != arr[index - 1].amount) {
            validateAmount = true
          }
        }

        // if (item.adjustType == '1') {
        //   up++
        // }

        // if (item.adjustType == '2') {
        //   down++
        // }
      })

      // if (up != down) {
      //   notification.open('error', {
      //     title: 'จำนวนประเภทการปรับปรุงต้องสอดคล้องกัน',
      //   })
      //   return
      //} else 
      if (validateAmount) {
        notification.open('error', {
          title: 'จำนวนเงินของคู่รายการปรับปรุงต้องเท่ากันเสมอ',
        })
        return
      }
      setRequest(formData)
    } else if (formTable.length == 0) {
      notification.open('error', {
        title: 'กรุณาเพิ่มรายการปรับปรุง อย่างน้อย 2 รายการ',
      })
      return
    } else if (formTable.length % 2 == 1) {
      notification.open('error', {
        title: 'รายการปรับปรุงต้องมีคู่รายการเสมอ',
      })
      return
    }

    setIsShowConfirm(true)
  }
  const DraftOnSumit = () => {
    const data = getValues()

    console.log('draft data', data)

    const formData = new FormData()

    formData.append('Id', adjustId || '')
    formData.append('ProjectCode', projectCode || '')
    formData.append('PeriodNumber', periodInfo?.periodNumber || 0)

    formData.append(
      'DocumentDate',
      data.documentDate ? moment(data.documentDate).format('YYYY/MM/DD') : ''
    )

    formData.append('Description', data.description || '')

    formData.append('IsDraft', true)

    if (Array.isArray(data.attachFiles)) {
      data.attachFiles.forEach((element) => {
        formData.append('AttachFiles', element.blobFile)
      })
    }

    if (Array.isArray(data.deleteFileIds)) {
      data.deleteFileIds.forEach((element) => {
        formData.append('DeleteFileIds', element)
      })
    }

    const formTable = data.table?.filter((i) => !i.isRowTotal) || []

    if (formTable.length > 0) {
      formTable.forEach((item, index) => {
        formData.set(
          `FormTable[${index}].Id`,
          item.id?.indexOf('addNew') !== -1 ? '' : item.id || ''
        )
        formData.set(`FormTable[${index}].Activity`, item.activity || '')
        formData.set(`FormTable[${index}].AdjustName`, item.adjustName || '')

        formData.set(
          `FormTable[${index}].BankAccount`,
          item.adjustTypeCode !== '6600' && item.adjustTypeCode !== '6800'
            ? ''
            : item.bankAccount || ''
        )

        formData.set(`FormTable[${index}].AdjustTypeCode`, item.adjustTypeCode || '')
        formData.set(`FormTable[${index}].AdjustType`, item.adjustType || '')
        formData.set(`FormTable[${index}].SubProject`, item.subProject || '')
        formData.set(`FormTable[${index}].Amount`, item.amount || 0)
      })
    }

    setRequest(formData)
    setIsShowConfirm(true)
  }
  const handlePreviewVoucher = async () => {
    // console.log('handlePreviewVoucher', fileObj)

    startLoading()
    setIsLoading(true)
    const PreviewVoucherData = sessionGetItemObj('PreviewVoucherData')
    // console.log('PreviewVoucherData', PreviewVoucherData)
    var file = await downloadAdjustListFile(
      PreviewVoucherData.projectCode,
      PreviewVoucherData.documentNumber,
      PreviewVoucherData.id
    )

    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.target = '_blank'
    link.setAttribute('value', PreviewVoucherData.name)
    document.body.appendChild(link)
    link.click()

    setIsLoading(false)
    doneLoading()
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      <Panel shaded collapsible defaultExpanded header={formSchema.header} bordered>
        <MiniProjectInfo schema={formSchema?.projectInfo} />

        {editMode && !formSchema.disabled ? (
          <UpdateListForm
            schema={formSchema?.form}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            clearErrors={clearErrors}
            periodInfo={periodInfo}
            onPreview={onPreview}
            onDownload={onDownload}
          />
        ) : (
          <UpdateListFormView
            schema={formSchema?.form}
            periodInfo={periodInfo}
            onPreview={onPreview}
            onDownload={onDownload}
          />
        )}

        <UpdateListTable
          schema={formSchema?.form?.formTable}
          enableEdit={editMode && !formSchema.disabled}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          getValues={getValues}
          setValue={setValue}
          clearErrors={clearErrors}
          isAddDisabled={formSchema?.form?.isAddDisabled}
        />

        <div>
          <br />
          <Row>
            {isError && (
              <Message showIcon type="error" description={isError} style={{ marginBottom: 10 }} />
            )}
            <Col lg={12} md={12} sm={24} xs={24}>
              {editMode && !formSchema.disabled && (
                <Button
                  color="red"
                  appearance="link"
                  onClick={() => {
                    setIsShowConfirmDelete(true)
                  }}
                  disabled={formSchema?.form?.isDeleteDisabled}
                >
                  <Icon icon="trash" size="lg" /> ลบเอกสาร
                </Button>
              )}
            </Col>
            <Col lg={12} md={12} sm={24} xs={24} style={{ textAlign: 'right' }}>
              {/* <Button color="blue" appearance="link">
                <Icon icon="search" size="lg" /> ดูตัวอย่าง
              </Button> */}
              <Button
                color="blue"
                appearance="link"
                disabled={formSchema?.form?.enableSaveDraft}
                onClick={() => {
                  handlePreviewVoucher()
                }}
              >
                <Icon icon="eye" size="lg" /> ดูใบสำคัญ
              </Button>
              {editMode && !formSchema.disabled && (
                <>
                  {formSchema?.form?.enableSaveDraft && (
                    <SaveButton onClick={DraftOnSumit} disabled={formSchema?.form?.isEditDisabled}>
                      บันทึกร่าง
                    </SaveButton>
                  )}

                  <SaveButton
                    onClick={handleSubmit(onSubmit)}
                    disabled={formSchema?.form?.isEditDisabled}
                  >
                    บันทึก
                  </SaveButton>
                  <CancelButton
                    onClick={() => {
                      sessionRemoveItem('adjustData')
                      history.goBack()
                    }}
                  >
                    ยกเลิก
                  </CancelButton>
                </>
              )}
            </Col>
          </Row>
        </div>
      </Panel>

      <ConfirmWidget
        title={'ยืนยันการบันทึก'}
        show={isShowConfirm}
        //detail={'ยืนยันการบันทึก'}
        onCancle={() => {
          setRequest()
          setIsShowConfirm(false)
        }}
        onConfirm={handleCallService}
      />

      <ConfirmWidget
        title={'ยืนยันลบเอกสาร'}
        show={isShowConfirmDelete}
        //detail={'ยืนยันลบเอกสาร'}
        onCancle={() => setIsShowConfirmDelete(false)}
        onConfirm={handleCallDelete}
      />
    </>
  )
}
